import React from "react";
import { NavLink, useLocation } from "react-router-dom";

import { visibleTabs } from "../areas";

/**
 * The contextual X-axis. Answers "Where am I within this area?"
 *
 * Driven entirely by the active area — the shell passes `areaId` and this reads
 * the ratified structure out of `areas.js`. No area supplies its own tab bar,
 * which is what keeps five sessions from producing five slightly different ones.
 *
 * Founder-only tabs are filtered by the same rule as the Y-axis and with the
 * same caveat: absence here is navigation, not access control. `/v2/brain/health`
 * typed directly still reaches the server, and the server still refuses it.
 *
 * An area with a single visible tab renders nothing. A tab bar with one tab is
 * furniture — it takes 46px of vertical space to tell the operator they have no
 * choice. That is the non-founder's view of Brain, per SHELL.md.
 *
 * THE SELECTED OFFER TRAVELS WITH THE TAB. The Workstation's contract, written
 * in its own code ("`selection` is resolved ONCE and handed to whichever tab is
 * showing, so switching tabs keeps the offer and no tab owns it"), was not what
 * happened: `useOfferSelection` keeps the offer in `?offer=` and these links
 * were built without it, so every tab click dropped it and the next screen
 * opened on "Select an offer…". Observed live on 2026-09-11 across Overview,
 * Compliance, Traffic Channels and Ads & Creative — five screens that looked
 * broken and were simply empty.
 *
 * Only `offer` is carried, not the whole query string: the rest of a screen's
 * query (a session id, a drawer that is open) belongs to the screen that wrote
 * it and must not follow the operator to a different tab.
 */
export default function XNav({ areaId, basePath, user }) {
  const location = useLocation();
  const tabs = visibleTabs(areaId, user);
  if (tabs.length < 2) return null;

  let carry = "";
  try {
    const offer = new URLSearchParams(location.search).get("offer");
    if (offer) carry = `?offer=${encodeURIComponent(offer)}`;
  } catch (e) {
    carry = "";
  }

  return (
    <nav className="xnav" aria-label="Section">
      {tabs.map((t) => (
        <NavLink
          key={t.tab || "index"}
          to={(t.tab ? `${basePath}/${t.tab}` : basePath) + carry}
          end={!t.tab}
          className={({ isActive }) => (isActive ? "xnav-item on" : "xnav-item")}
        >
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}
